<template>
  <!--如果账号已经绑定，则在右下角显示绑定的绿色勾勾。-->
  <!--已经绑定的账号，再次点击，则调起DebindAccount提示框，在debindAccount 提示框点击确定之后，调用原生接绑操作。-->
  <Block type="accountDialog" class="dialog-container account-dialog">
    <Block type="accountDialogContainer" class="account-dialog-container">
      <Title type="dialogTitle" class="dialog-title">
        {{ languages.bind.toUpperCase() }}
      </Title>
      <p class="bind-tips dialog-tips">{{ languages.bindTps }}</p>
      <div class="swtich-ways" :class="isFiveColsStyle ? 'third-style' : false">
        <a
          class="swtich-way j-bind-em-btn"
          @click="bindAccount('em')"
          v-if="em"
          v-touchActive
        >
          <div class="way-icon em"></div>
          <p class="way-name hide">Sign in with Email</p>
          <em
            class="bindIcon"
            v-if="
              (emBinded && isH5) ||
              (emBinded && !isH5 && !unBindState) ||
              (emBinded && !isH5 && unBindState && !canEmDebind)
            "
          ></em>
          <p
            class="apply-debind"
            v-if="emBinded && !isH5 && unBindState && canEmDebind"
            @click="applyDebind('em')"
          >
            {{ languages.unbindApply }}
          </p>
        </a>
        <a
          class="swtich-way j-bind-ph-btn"
          @click="bindAccount('ph')"
          v-if="ph"
          v-touchActive
        >
          <div class="way-icon ph"></div>
          <p class="way-name hide">Sign in with Phone</p>
          <em
            class="bindIcon"
            v-if="
              (phBinded && isH5) ||
              (phBinded && !isH5 && !unBindState) ||
              (phBinded && !isH5 && unBindState && !canPhDebind)
            "
          ></em>
          <p
            class="apply-debind"
            v-if="phBinded && !isH5 && unBindState && canPhDebind"
            @click="applyDebind('ph')"
          >
            {{ languages.unbindApply }}
          </p>
        </a>
        <a
          class="swtich-way j-bind-ap-btn"
          @click="bindAccount('ap')"
          v-if="ap && !hideSomeBindBtn"
          v-touchActive
        >
          <div class="way-icon ap"></div>
          <p class="way-name hide">Sign in with Apple</p>
          <em
            class="bindIcon"
            v-if="
              (apBinded && isH5) ||
              (apBinded && !isH5 && !unBindState) ||
              (apBinded && !isH5 && unBindState && !canApDebind)
            "
          ></em>
          <p
            class="apply-debind"
            v-if="apBinded && !isH5 && unBindState && canApDebind"
            @click="applyDebind('ap')"
          >
            {{ languages.unbindApply }}
          </p>
        </a>
        <div class="swtich-way" v-if="fb && !hideSomeBindBtn" v-touchActive>
          <a class="swtich-way-bind j-bind-fb-btn" @click="bindAccount('fb')">
            <div class="way-icon fb"></div>
            <p class="way-name hide">Facebook</p>
            <em
              class="bindIcon"
              v-if="
                (fbBinded && isH5) ||
                (fbBinded && !isH5 && !unBindState) ||
                (fbBinded && !isH5 && unBindState && !canFbDebind)
              "
            ></em>
            <p
              class="apply-debind"
              v-if="fbBinded && !isH5 && unBindState && canFbDebind"
              @click="applyDebind('fb')"
            >
              {{ languages.unbindApply }}
            </p>
          </a>
        </div>
        <div class="swtich-way" v-if="tw && !hideSomeBindBtn" v-touchActive>
          <a class="swtich-way-bind j-bind-tw-btn" @click="bindAccount('tw')">
            <div class="way-icon tw"></div>
            <p class="way-name hide">Twitter</p>
            <em
              class="bindIcon"
              v-if="
                (twBinded && isH5) ||
                (twBinded && !isH5 && !unBindState) ||
                (twBinded && !isH5 && unBindState && !canTwDebind)
              "
            ></em>
            <p
              class="apply-debind"
              v-if="twBinded && !isH5 && unBindState && canTwDebind"
              @click="applyDebind('tw')"
            >
              {{ languages.unbindApply }}
            </p>
          </a>
        </div>
        <a
          class="swtich-way j-bind-ln-btn"
          @click="bindAccount('ln')"
          v-if="ln"
          v-touchActive
        >
          <div class="way-icon ln"></div>
          <p class="way-name hide">Line</p>
          <em
            class="bindIcon"
            v-if="
              (lnBinded && isH5) ||
              (lnBinded && !isH5 && !unBindState) ||
              (lnBinded && !isH5 && unBindState && !canLnDebind)
            "
          ></em>
          <p
            class="apply-debind"
            v-if="lnBinded && !isH5 && unBindState && canLnDebind"
            @click="applyDebind('ln')"
          >
            {{ languages.unbindApply }}
          </p>
        </a>
        <a
          class="swtich-way j-bind-nv-btn"
          @click="bindAccount('nv')"
          v-if="nv"
          v-touchActive
        >
          <div class="way-icon nv"></div>
          <p class="way-name hide">Naver</p>
          <em
            class="bindIcon"
            v-if="
              (nvBinded && isH5) ||
              (nvBinded && !isH5 && !unBindState) ||
              (nvBinded && !isH5 && unBindState && !canNvDebind)
            "
          ></em>
          <p
            class="apply-debind"
            v-if="nvBinded && !isH5 && unBindState && canNvDebind"
            @click="applyDebind('nv')"
          >
            {{ languages.unbindApply }}
          </p>
        </a>
        <a
          class="swtich-way j-bind-mg-btn"
          @click="bindAccount('mg')"
          v-if="mg"
          v-touchActive
        >
          <div class="way-icon mg"></div>
          <p class="way-name hide">followCode</p>
          <em class="bindIcon" v-if="mgBinded"></em>
        </a>
        <div class="swtich-way" v-if="gp" v-touchActive>
          <a class="swtich-way-bind j-bind-gp-btn" @click="bindAccount('gp')">
            <div class="way-icon gp"></div>
            <p class="way-name hide">Google play</p>
            <em
              v-if="
                (gpBinded && isH5) ||
                (gpBinded && !isH5 && !unBindState) ||
                (gpBinded && !isH5 && unBindState && !canGpDebind)
              "
              class="bindIcon"
            ></em>
            <p
              class="apply-debind"
              v-if="gpBinded && !isH5 && unBindState && canGpDebind"
              @click="applyDebind('gp')"
            >
              {{ languages.unbindApply }}
            </p>
          </a>
        </div>
        <div class="swtich-way" v-if="gc" v-touchActive>
          <a class="swtich-way-bind j-bind-gc-btn" @click="bindAccount('gc')">
            <div class="way-icon gc"></div>
            <p class="way-name hide">Game Center</p>
            <em
              v-if="
                (gcBinded && isH5) ||
                (gcBinded && !isH5 && !unBindState) ||
                (gcBinded && !isH5 && unBindState && !canGcDebind)
              "
              class="bindIcon"
            ></em>
            <p
              class="apply-debind"
              v-if="gcBinded && !isH5 && unBindState && canGcDebind"
              @click="applyDebind('gc')"
            >
              {{ languages.unbindApply }}
            </p>
          </a>
        </div>
        <a
          class="swtich-way j-bind-hw-btn"
          @click="bindAccount('hw')"
          v-if="hw"
          v-touchActive
        >
          <div class="way-icon hw"></div>
          <p class="way-name hide">HUAWEI</p>
          <em
            v-if="
              (hwBinded && isH5) ||
              (hwBinded && !isH5 && !unBindState) ||
              (hwBinded && !isH5 && unBindState && !canHwDebind)
            "
            class="bindIcon"
          ></em>
          <p
            class="apply-debind"
            v-if="hwBinded && !isH5 && unBindState && canHwDebind"
            @click="applyDebind('hw')"
          >
            {{ languages.unbindApply }}
          </p>
        </a>
        <a
          class="swtich-way j-bind-vk-btn"
          @click="bindAccount('vk')"
          v-if="vk"
          v-touchActive
        >
          <div class="way-icon vk"></div>
          <p class="way-name hide">VK</p>
          <em
            class="bindIcon"
            v-if="
              (vkBinded && isH5) ||
              (vkBinded && !isH5 && !unBindState) ||
              (vkBinded && !isH5 && unBindState && !canVkDebind)
            "
          ></em>
          <p
            class="apply-debind"
            v-if="vkBinded && !isH5 && unBindState && canVkDebind"
            @click="applyDebind('vk')"
          >
            {{ languages.unbindApply }}
          </p>
        </a>
      </div>
    </Block>
    <Button
      type="closeBtn"
      class="close-btn j-close-bind-account-popup"
      @click="closeDialog"
      v-touchActive
    ></Button>
    <PopupWindow
      type="confirm"
      @onCancel="debindDialogState = false"
      @onConfirm="debindAccount"
      v-if="debindDialogState"
      :languages="languages"
      :content="languages.debindTips"
    ></PopupWindow>
    <PopupWindow
      type="confirm"
      @onCancel="showAutoDebindFailPopup = false"
      @onConfirm="contactService"
      v-if="showAutoDebindFailPopup"
      :languages="languages"
      :content="languages.unbindServiceTip"
      :title="languages.unbindServiceTitle"
      :cancel="languages.close"
      :confirm="languages.unbindContact"
    ></PopupWindow>
    <PopupWindow
      type="confirm"
      @onCancel="showDebindConfirmPopup = false"
      @onConfirm="doDebind"
      v-if="showDebindConfirmPopup"
      :languages="languages"
      :content="languages.unbindConfirmTip"
      :title="languages.unbindConfirmTitle"
      :cancel="languages.unbindExit"
      :confirm="languages.unbindConfirm"
    ></PopupWindow>
  </Block>
</template>
<script>
import {
  DO_DEBIND,
  GET_CAN_DEBIND_TYPE,
  UPDATE_PLATFORM_ACCOUNT_POPUP_VISIBLE,
  UPDATE_PLATFORM_ACCOUNT_BIND,
  UPDATE_PLATFORM_ACCOUNT_UNBIND,
  UPDATE_PLATFORM_ACCOUNT_TYPE
} from '@store/account.js';
import { TOST } from '@store/dialog.js';
import bridge from '@utiles/bridge';
const ANDROID = 'android';
const IOS = 'ios';
const PC = 'pc';
const typeOriginName = {
  fb: 'facebook',
  ap: 'apple',
  gp: 'google',
  hw: 'hw_login',
  ln: 'line',
  nv: 'naver',
  tw: 'twitter',
  vk: 'vk',
  gc: 'game_center'
};
export default {
  props: [
    'isAndroid',
    'HIDE_DIALOG',
    'DEBIND_ACCOUNT',
    'DEBIND_STATE',
    'BIND_ACCOUNT',
    'BIND_STATE',
    'GET_BIND_REWARD',
    'globalConfig',
    'isServerEnv',
    'gameId'
  ],
  data() {
    let packageName = this.globalConfig.getHrefParam('packageName');
    let packageVersion = this.globalConfig.getHrefParam('packageVersion');

    let CacheToken = this.globalConfig.getHrefParam('CacheToken');
    return {
      devicePlate: this.globalConfig.getHrefParam('devicePlate'),
      ANDROID: ANDROID,
      IOS: IOS,
      hideSomeBindBtn:
        packageName === 'com.global.kingdom.ios' && CacheToken == 1,
      bindBtnState: {
        ap: true,
        fb: true,
        tw: true,
        ln: true,
        nv: true,
        mg: true,
        gp: true,
        gc: true,
        hw: true,
        vk: true,
        em: true, // 平台账号走另外流程，这里用不到这个值
        ph: true // 平台账号走另外流程，这里用不到这个值
      },
      debindDialogState: false,
      curType: '',
      showAutoDebindFailPopup: false,
      showDebindConfirmPopup: false
    };
  },
  computed: {
    deviceType() {
      let device = this.isAndroid ? ANDROID : IOS;
      return device;
    },
    languages() {
      return this.$store.state.passport.languages;
    },
    uploadPointName() {
      return {
        em: this.languages?.emailAccount,
        ph: this.languages?.phoneAccount,
        ap: 'Sign in with Apple',
        fb: 'Facebook',
        tw: 'Twitter',
        ln: 'Line',
        nv: 'Naver',
        mg: 'followCode',
        gp: 'Google play',
        gc: 'Game Center',
        hw: 'HUAWEI',
        vk: 'VK'
      };
    },
    isFiveColsStyle() {
      // 这里需要过滤引继码
      let bindSupportArrLen = this.$store.state.account.bindSupportArr.length;
      if (this.$store.state.account.bindSupportArr.includes('mg')) {
        bindSupportArrLen = bindSupportArrLen - 1;
      }
      return bindSupportArrLen === 5;
    },
    fb() {
      return this.$store.state.account.bindSupportArr.includes('fb');
    },
    gp() {
      // 2025-07-31 添加hasStorageAccess判断，在低版本浏览器中隐藏入口。
      return (
        this.$store.state.account.bindSupportArr.includes('gp') &&
        (this.devicePlate != PC ||
          (this.devicePlate == PC && !!document.hasStorageAccess))
      );
    },
    gc() {
      return this.$store.state.account.bindSupportArr.includes('gc');
    },
    tw() {
      return (
        this.$store.state.account.bindSupportArr.includes('tw') &&
        (this.globalConfig.getHrefParam('h5') === '1' || this.gameId !== '171')
      );
    },
    ln() {
      return this.$store.state.account.bindSupportArr.includes('ln');
    },
    nv() {
      return this.$store.state.account.bindSupportArr.includes('nv');
    },
    ap() {
      return this.$store.state.account.bindSupportArr.includes('ap');
    },
    hw() {
      return this.$store.state.account.bindSupportArr.includes('hw');
    },
    vk() {
      return this.$store.state.account.bindSupportArr.includes('vk');
    },
    mg() {
      return 0;
    },
    em() {
      return this.$store.state.account.bindSupportArr.includes('em');
    },
    ph() {
      return this.$store.state.account.bindSupportArr.includes('ph');
    },
    bindStr() {
      return this.$store.state.bindStr;
    },
    bindTips() {
      return this.$store.state.bindTips;
    },
    fbBinded() {
      return this.$store.state.account.fb.status == this.BIND_STATE;
    },
    twBinded() {
      return this.$store.state.account.tw.status == this.BIND_STATE;
    },
    lnBinded() {
      return this.$store.state.account.ln.status == this.BIND_STATE;
    },
    nvBinded() {
      return this.$store.state.account.nv.status == this.BIND_STATE;
    },
    mgBinded() {
      return this.$store.state.account.mg.status == this.BIND_STATE;
    },
    hwBinded() {
      return this.$store.state.account.hw.status == this.BIND_STATE;
    },
    gpBinded() {
      return this.$store.state.account.gp.status == this.BIND_STATE;
    },
    gcBinded() {
      return this.$store.state.account.gc.status == this.BIND_STATE;
    },
    vkBinded() {
      return this.$store.state.account.vk.status == this.BIND_STATE;
    },
    emBinded() {
      return this.$store.state.account.em.status == this.BIND_STATE;
    },
    phBinded() {
      return this.$store.state.account.ph.status == this.BIND_STATE;
    },
    languages() {
      return this.$store.state.passport.languages;
    },
    apBinded() {
      return this.$store.state.account.ap.status == this.BIND_STATE;
    },
    unBindState() {
      return this.$store.state.passport.unBindState;
    },
    isH5() {
      return this.globalConfig.getHrefParam('h5') === '1';
    },
    canDebindType() {
      return this.$store.state.account.canDebindType;
    },
    canApDebind() {
      return this.canDebindType.includes('apple');
    },
    canFbDebind() {
      return this.canDebindType.includes('facebook');
    },
    canTwDebind() {
      return this.canDebindType.includes('twitter');
    },
    canLnDebind() {
      return this.canDebindType.includes('line');
    },
    canNvDebind() {
      return this.canDebindType.includes('naver');
    },
    canGpDebind() {
      return this.canDebindType.includes('google');
    },
    canGcDebind() {
      return this.canDebindType.includes('game_center');
    },
    canHwDebind() {
      return this.canDebindType.includes('hw_login');
    },
    canVkDebind() {
      return this.canDebindType.includes('vk');
    },
    canEmDebind() {
      return this.canDebindType.includes('email');
    },
    canPhDebind() {
      return this.canDebindType.includes('phone');
    }
  },
  methods: {
    closeDialog() {
      this.$store.dispatch(this.HIDE_DIALOG);
    },
    platformBindAccount(sdkTypeName) {
      this.$store.commit(UPDATE_PLATFORM_ACCOUNT_BIND, true); // 绑定模式
      this.$store.commit(UPDATE_PLATFORM_ACCOUNT_UNBIND, false); // 非解绑
      this.$store.commit(UPDATE_PLATFORM_ACCOUNT_TYPE, sdkTypeName); // 是平台账号邮箱还是手机
      this.$store.commit(UPDATE_PLATFORM_ACCOUNT_POPUP_VISIBLE, true);
    },
    platformUnBindAccount(sdkTypeName) {
      this.$store.commit(UPDATE_PLATFORM_ACCOUNT_BIND, false); // 非绑定模式
      this.$store.commit(UPDATE_PLATFORM_ACCOUNT_UNBIND, true); // 解绑
      this.$store.commit(UPDATE_PLATFORM_ACCOUNT_TYPE, sdkTypeName); // 是平台账号邮箱还是手机
      this.$store.commit(UPDATE_PLATFORM_ACCOUNT_POPUP_VISIBLE, true);
    },
    bindAccount(type) {
      if (this.$store.state.account[type].status == this.DEBIND_STATE) {
        if (!this.bindBtnState[type]) {
          return false;
        }
        if (type === 'em' || type === 'ph') {
          this.platformBindAccount(type);
          return;
        }
        this.bindBtnState[type] = false;
        this.$store
          .dispatch(this.BIND_ACCOUNT, type)
          .then(res => {
            this.bindBtnState[type] = true;
            this.updateDebindType();
            // 是否启用绑定领奖 0不启用 1启用
            var allowBind = this.$store.state.account.isAllowBindState;
            // 是否已经领取绑定领奖奖励 0未领取 1已领取
            var isBind = this.$store.state.account.isBindRewardState;
            if (allowBind && !isBind) {
              // 绑定发奖
              var gameId = this.globalConfig.getHrefParam('gameId');
              var serverId = this.globalConfig.getHrefParam('serverId');
              var roleId = this.globalConfig.getHrefParam('roleId');
              if (gameId && serverId && roleId) {
                /*
                  需求：绑定领奖接口调用下架
                  时间：2022/03/14
                  需求方：安韶
                  需求背景：当前全球平台用户中心绑定领奖接口依托SDK悬浮窗功能配置，且当前没有配置相关领奖，同时绑定领奖和悬浮窗功能应该解藕，暂时下架绑定领奖接口调用。

                  this.$store
                    .dispatch(GET_BIND_REWARD)
                    .then(res => {})
                    .catch();
                */
              }
            }

            // 绑定成功打点 用户在取消绑定时客户端会返回-1（可能还有其他情况返回-1），成功时会返回1，失败时会返回0
            if (res?.result == 1) {
              // 绑定成功打点
              window?.passportv2DataLayer?.push({
                eventName: 'bind_sns',
                eventValue: '', // 成功留空
                eventType: this?.uploadPointName[type] || '',
                eventReason: '绑定成功'
              });
            } else {
              // 绑定失败打点
              window?.passportv2DataLayer?.push({
                eventName: 'bind_sns',
                eventValue: { code: '', msg: res?.msg },
                eventType: this?.uploadPointName[type] || '',
                eventReason: '绑定失败'
              });
            }
          })
          .catch(err => {
            this.bindBtnState[type] = true;
            this.$emit('bindFail', err.message);
            window?.passportv2DataLayer?.push({
              eventName: 'bind_sns',
              eventValue: { code: '', msg: err?.message },
              eventType: this?.uploadPointName[type] || '',
              eventReason: '绑定失败'
            });
          });
      }
    },
    readyDebindAccount(type) {
      this.curType = type;
      if (this.unBindState) {
        this.debindDialogState = true;
      }
    },
    debindAccount() {
      this.debindDialogState = false;
      this.bindBtnState[this.curType] = false;
      this.$store
        .dispatch(this.DEBIND_ACCOUNT, this.curType)
        .then(() => {
          this.bindBtnState[this.curType] = true;
        })
        .catch(err => {
          this.bindBtnState[this.curType] = true;
          this.$emit('bindFail', err.message);
        });
    },
    applyDebind(type) {
      console.log('解绑:', type);
      if (type === 'em' || type === 'ph') {
        this.platformUnBindAccount(type);
        return;
      }
      this.curType = type;
      this.showDebindConfirmPopup = true;
    },
    contactService() {
      this.$emit('feedbackPage');
      this.showAutoDebindFailPopup = false;
    },
    doDebind() {
      this.bindBtnState[this.curType] = false;
      this.$store
        .dispatch(DO_DEBIND, this.getDebindActionParam(this.curType))
        .then(() => {
          this.bindBtnState[this.curType] = true;
          this.showDebindConfirmPopup = false;
          this.$store.dispatch(TOST, this.languages.unbindSucc);
          this.updateDebindType();
          this.handleAndroidLogout();
        })
        .catch(_err => {
          this.showDebindConfirmPopup = false;
          this.bindBtnState[this.curType] = true;
          this.$store.dispatch(TOST, this.languages.unbindFail);
          this.updateDebindType();
        });
    },
    getDebindActionParam(type) {
      return {
        gameId: this.gameId || '',
        packageName: this.globalConfig.getHrefParam('packageName') || '',
        devicePlate: this.globalConfig.getHrefParam('devicePlate') || '',
        androidid: this.globalConfig.getHrefParam('androidid') || '',
        idfa: this.globalConfig.getHrefParam('idfa') || '',
        gpid: this.globalConfig.getHrefParam('gpid') || '',
        unbindType: typeOriginName[type],
        type: type
      };
    },
    // 针对无自动登录版本的android，当前登录方式与解绑一样时，调用sdk退出登录接口，回到游客登录
    handleAndroidLogout() {
      if (!this.isAndroid) {
        return;
      }
      let thirdPlatForm = this.globalConfig.getHrefParam('thirdPlatForm') || '';
      if (!thirdPlatForm || thirdPlatForm === 'auto_login') {
        return;
      }
      const thirdPlatFormMap = {
        fb: 'fb',
        gp: 'google',
        hw: 'huawei',
        ln: 'line',
        nv: 'naver',
        tw: 'tw',
        vk: 'vk'
      };
      if (
        thirdPlatFormMap[this.curType] &&
        thirdPlatFormMap[this.curType] === thirdPlatForm
      ) {
        bridge.callSdkMethod('logout', {});
      }
    },
    updateDebindType() {
      this.unBindState &&
        !this.isH5 &&
        this.$store.dispatch(GET_CAN_DEBIND_TYPE, {
          gameId: this.gameId || '',
          packageName: this.globalConfig.getHrefParam('packageName') || '',
          devicePlate: this.globalConfig.getHrefParam('devicePlate') || '',
          androidid: this.globalConfig.getHrefParam('androidid') || '',
          idfa: this.globalConfig.getHrefParam('idfa') || '',
          gpid: this.globalConfig.getHrefParam('gpid') || ''
        });
    }
  }
};
</script>
